"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var angleDoubleDown = exports.angleDoubleDown = { "viewBox": "0 0 1152 1792", "children": [{ "name": "path", "attribs": { "d": "M1075 864q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23zM1075 480q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/angleDoubleDown.js
// module id = 941
// module chunks = 1